import { useContext } from 'react';
import { AlgoliaConnectorContext } from '../context/AlgoliaConnectorContext';

export const useAlgoliaConnector = () => {
    return useContext(AlgoliaConnectorContext);
};
